import React from 'react'
import { UIContactMe } from '../../../UI/UIHomePage/UIContactMe/UIContactMe.jsx'

export const ContactMeSection = () => {
  return (
    <UIContactMe />
  )
}
